(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdl-comparator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fdl-comparator')) {
    customElements.define('fdl-comparator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.templates = new Map(Array.from(this.querySelectorAll('template[data-lamp]'), node => [node.dataset.lamp, node]));
        this.selects = Array.from(this.querySelectorAll('[data-select]'));
        this.rows = Array.from(this.querySelectorAll('[data-field]'));
        this.searchInput = this.querySelector('[data-search]');
        this.differences = this.querySelector('[data-differences]');
        this.status = this.querySelector('[data-status]');
        const handles = Array.from(this.templates.keys());
        if (handles.length < 2) {
          this.querySelector('[data-insufficient]').hidden = false;
          return;
        }
        this.defaults = [this.dataset.defaultLeft, this.dataset.defaultRight].map((handle, i) => this.templates.has(handle) ? handle : handles[i]);
        if (this.defaults[0] === this.defaults[1]) this.defaults[1] = handles.find(handle => handle !== this.defaults[0]);
        let saved;
        try { saved = JSON.parse(sessionStorage.getItem('fdl-comparison-v1') || 'null'); } catch (_) {}
        const params = new URLSearchParams(location.search);
        const requested = params.get('compare')?.split(',');
        const usable = pair => Array.isArray(pair) && pair.length === 2 && pair[0] !== pair[1] && pair.every(handle => this.templates.has(handle));
        this.selected = usable(requested) ? requested : usable(saved) ? saved : this.defaults.slice();
        this.selects.forEach((select, index) => select.addEventListener('change', () => {
          if (!this.templates.has(select.value) || select.value === this.selected[1 - index]) {
            select.value = this.selected[index];
            this.status.textContent = this.dataset.same;
            return;
          }
          this.selected[index] = select.value;
          this.render(true);
        }));
        this.searchInput.addEventListener('input', () => this.updateOptions());
        this.differences.addEventListener('change', () => this.filterRows());
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.selected = this.defaults.slice();
          this.searchInput.value = '';
          this.differences.checked = false;
          this.render(true);
        });
        this.render(false);
        this.querySelector('.fdlc__interface').hidden = false;
      }
      normalized(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      }
      updateOptions() {
        const query = this.normalized(this.searchInput.value);
        let matches = 0;
        for (const template of this.templates.values()) if (this.normalized(template.dataset.name).includes(query)) matches++;
        this.selects.forEach((select, index) => {
          const options = [];
          for (const [handle, template] of this.templates) {
            if (query && !this.normalized(template.dataset.name).includes(query) && !this.selected.includes(handle)) continue;
            const option = document.createElement('option');
            option.value = handle;
            option.textContent = template.dataset.name;
            option.disabled = handle === this.selected[1 - index];
            option.selected = handle === this.selected[index];
            options.push(option);
          }
          select.replaceChildren(...options);
        });
        this.querySelector('[data-search-status]').textContent = query && matches === 0 ? this.dataset.noResults : '';
      }
      render(announce) {
        this.updateOptions();
        const cards = this.querySelector('[data-cards]');
        const selectedTemplates = this.selected.map(handle => this.templates.get(handle));
        cards.replaceChildren(...selectedTemplates.map(template => template.content.querySelector('article').cloneNode(true)));
        this.querySelectorAll('[data-column-name]').forEach((node, index) => { node.textContent = selectedTemplates[index].dataset.name; });
        this.rows.forEach(row => {
          const values = selectedTemplates.map(template => template.content.querySelector('[data-value="' + row.dataset.field + '"]')?.textContent.trim() || '');
          const different = values[0] !== '' && values[1] !== '' && values[0] !== values[1];
          row.toggleAttribute('data-different', different);
          row.dataset.equal = values[0] !== '' && values[1] !== '' && values[0] === values[1] ? 'true' : 'false';
          row.querySelectorAll('[data-cell]').forEach((cell, index) => {
            cell.textContent = values[index] || this.dataset.empty;
            cell.classList.toggle('fdlc__missing', !values[index]);
          });
        });
        this.filterRows();
        try { sessionStorage.setItem('fdl-comparison-v1', JSON.stringify(this.selected)); } catch (_) {}
        if (announce) {
          this.status.textContent = this.dataset.updated + ' ' + selectedTemplates.map(template => template.dataset.name).join(' / ');
          try {
            const url = new URL(location.href);
            url.searchParams.set('compare', this.selected.join(','));
            history.replaceState(history.state, '', url);
          } catch (_) {}
        }
      }
      filterRows() {
        this.rows.forEach(row => { row.hidden = this.differences.checked && row.dataset.equal === 'true'; });
        this.querySelector('[data-all-equal]').hidden = !this.rows.every(row => row.hidden);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdl-favorites"] && !Shopify.designMode) return;
  try {
    
(function(){
  function productKey(link){
    if(!link) return '';
    try { return new URL(link.href, window.location.origin).pathname.replace(/\/$/,''); }
    catch(error){ return link.getAttribute('href') || ''; }
  }

  function captureEditorial(container){
    var editorial={};
    if(!container) return editorial;
    container.querySelectorAll('.fdlh-product__link[href]').forEach(function(link){
      var key=productKey(link);
      if(!key) return;
      var title=link.querySelector('h3,h4');
      var note=link.querySelector('.fdlh-product__note');
      editorial[key]={
        title:title ? title.textContent.trim() : '',
        note:note ? note.textContent.trim() : ''
      };
    });
    return editorial;
  }

  function restoreEditorial(container,editorial,personal){
    if(!container) return;
    container.querySelectorAll('.fdlh-product__link[href]').forEach(function(link){
      var data=editorial[productKey(link)];
      if(!data) return;
      var title=link.querySelector('h3,h4');
      var body=link.querySelector('.fdlh-product__body');
      if(data.title && title) title.textContent=data.title;
      var oldNote=link.querySelector('.fdlh-product__note');
      if(oldNote) oldNote.remove();
      if(data.note && body){
        var note=document.createElement('p');
        note.className='fdlh-product__note'+(personal?' fdlh-product__note--personal':'');
        note.textContent=data.note;
        if(title) title.insertAdjacentElement('afterend',note);
        else body.prepend(note);
      }
    });
  }

  function insertEnhancements(home,source){
    var trust=home.querySelector('.fdlh-trust');
    var quickTemplate=source.querySelector('template[data-fdl-quick-nav-template]');
    if(trust&&quickTemplate&&!home.querySelector('[data-fdl-quick-nav]')){
      trust.parentNode.insertBefore(quickTemplate.content.cloneNode(true),trust.nextSibling);
    }

    var favorites=home.querySelector('#selection-du-moment');
    var newTemplate=source.querySelector('template[data-fdl-new-arrivals-template]');
    if(favorites&&newTemplate&&!home.querySelector('[data-fdl-new-arrivals]')){
      favorites.parentNode.insertBefore(newTemplate.content.cloneNode(true),favorites);
    }
  }

  function setupCollectionSources(){
    var source=document.querySelector('.fdlh-auto-usage-templates');
    var home=document.querySelector('.fdl-home');
    if(!source||!home)return;
    var usages=home.querySelector('.fdlh-usages');
    if(usages){
      ['professionnel','randonnee','portee','urbex','inspection','quotidien'].forEach(function(key){
        var panel=usages.querySelector('[data-usage-key="'+key+'"]');
        var template=source.querySelector('template[data-fdl-usage-template="'+key+'"]');
        if(!panel||!template||panel.dataset.fdlAutoSource==='collection')return;
        var main=panel.querySelector('.fdlh-products--usage:not(.fdlh-products--secondary)');
        if(!main)return;
        var mainEditorial=captureEditorial(main);
        main.innerHTML='';
        main.appendChild(template.content.cloneNode(true));
        restoreEditorial(main,mainEditorial,false);

        var secondaryTemplate=source.querySelector('template[data-fdl-secondary-template="'+key+'"]');
        var secondary=panel.querySelector('.fdlh-secondary');
        if(secondaryTemplate&&secondary){
          var secondaryProducts=secondary.querySelector('.fdlh-products--secondary');
          if(secondaryProducts){
            var secondaryEditorial=captureEditorial(secondaryProducts);
            secondaryProducts.innerHTML='';
            secondaryProducts.appendChild(secondaryTemplate.content.cloneNode(true));
            restoreEditorial(secondaryProducts,secondaryEditorial,false);
          }
        }else if(secondary){
          secondary.remove();
        }
        panel.dataset.fdlAutoSource='collection';
      });
    }

    var favoriteTemplate=source.querySelector('template[data-fdl-favorites-template]');
    var favoriteTarget=home.querySelector('#selection-du-moment .fdlh-products--featured');
    if(favoriteTemplate&&favoriteTarget&&favoriteTarget.dataset.fdlAutoSource!=='collection'){
      var favoriteEditorial=captureEditorial(favoriteTarget);
      favoriteTarget.innerHTML='';
      favoriteTarget.appendChild(favoriteTemplate.content.cloneNode(true));
      restoreEditorial(favoriteTarget,favoriteEditorial,true);
      favoriteTarget.dataset.fdlAutoSource='collection';
    }
    insertEnhancements(home,source);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setupCollectionSources,{once:true});
  else setupCollectionSources();
  document.addEventListener('shopify:section:load',setupCollectionSources);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdl-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fdl-home')) {
    customElements.define('fdl-home', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-usage-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-usage-panel]'));
        const navigation = this.querySelector('[data-usage-nav]');
        if (!navigation || !this.tabs.length) return;
        navigation.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          const panel = this.panels[index];
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.setAttribute('tabindex', '0');
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault(); this.activate(index, true);
          });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key !== ' ') return;
            event.preventDefault(); this.activate(next, true); this.tabs[next].focus();
          });
        });
        this.activate(0);
        this.onHash = () => {
          const query = new URL(window.location.href).searchParams.get('usage');
          const key = query === 'tactique' ? 'professionnel' : query;
          let index = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
          if (index < 0 && key) index = this.panels.findIndex(panel => panel.dataset.usageKey === key);
          if (index >= 0) this.activate(index);
        };
        this.onBlock = event => {
          const index = this.tabs.findIndex(tab => tab.dataset.usageChoice === event.detail.blockId);
          if (index >= 0) this.activate(index);
        };
        this.onHash();
        window.addEventListener('hashchange', this.onHash);
        document.addEventListener('shopify:block:select', this.onBlock);
      }
      activate(index, updateAddress = false) {
        this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.setAttribute('tabindex', i === index ? '0' : '-1'); });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (updateAddress && this.panels[index]) {
          const address = new URL(window.location.href);
          address.searchParams.set('usage', this.panels[index].dataset.usageKey);
          address.hash = 'choisir-par-usage';
          window.history.replaceState(window.history.state, '', address);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHash);
        document.removeEventListener('shopify:block:select', this.onBlock);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
